var React = require('react');

function WaveRTL (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M255.397 106.85C347.319 82.8743 371.866 32.6632 375 0V230H0C0 98.0089 127.802 128.693 223.538 113.105C231.842 111.753 246.779 109.098 255.397 106.85Z","fill":"currentColor"}));
}

WaveRTL.defaultProps = {"viewBox":"0 0 375 230","fill":"none"};

module.exports = WaveRTL;

WaveRTL.default = WaveRTL;
